<script setup>
import { getSmartPlatform } from '@weathernews/btos-javascript-modules/src/wniutil/common.js'

const route = useRoute()
const mapName = route.params.pref
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isMobile = ref(false)
const isMapView = () => {
  if (mapName === 'tokyo' || mapName === 'aichi' || mapName === 'osaka') {
    return true
  }
  return false
}
if (!isValidAreaAndPref(route.params.area, mapName)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('pref', getFullPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(route.params.area, mapName)
const [pickupLivecamList, pointLivecamList] = await Promise.all([
  useFetch('/api/livecam/pickuplist', { query: { target: mapName } }),
  useFetch('/api/livecam/pointlist', { query: { target: mapName } })
]).then((responses) => responses.map((res) => res.data))
const { sortPickupLivecamList, sortRemainingPreflist } = sortPrefLivecamData(pickupLivecamList.value, pointLivecamList.value)

onMounted(() => {
  isMobile.value = getSmartPlatform() !== ''
})
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :pref="getPrefectureName(mapName)"
      :pref-roma="mapName"
    >
      <template v-if="isMapView()">
        <div class="frame">
          <LivecamPrefMap :pref="mapName" />
        </div>
      </template>
      <template v-if="!isMapView()&&!isMobile">
        <div class="frame">
          <CommonPageTitle
            :title="`${getPrefectureName(mapName)}のライブカメラ`"
          />
          <LivecamList
            :list="sortPickupLivecamList"
          />
        </div>
      </template>
      <template #main-bottom>
        <template v-if="isMapView()">
          <LivecamList
            :list="sortPickupLivecamList"
          />
        </template>
        <template v-if="!isMapView()&&isMobile">
          <CommonPageTitle
            :title="`${getPrefectureName(mapName)}のライブカメラ`"
          />
          <LivecamList
            :list="sortPickupLivecamList"
          />
          <div
            id="ads-btf2-sp"
            class="ads-btf2-sp"
          />
        </template>
        <LivecamPointList
          v-if="sortRemainingPreflist.length!==0"
          :list="sortRemainingPreflist"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <HorizontalStackAd
          v-if="!isWebViewFlag&&isMapView()"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <TopicList />
        <HorizontalStackAd
          v-if="!isWebViewFlag&&!isMapView()"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-atf1-sp {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
.ads-btf2-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
